import { render, staticRenderFns } from "./RequEditAbout.vue?vue&type=template&id=2db63b35&scoped=true&"
import script from "./RequEditAbout.vue?vue&type=script&lang=js&"
export * from "./RequEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db63b35",
  null
  
)

export default component.exports